import React from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { showDate } from '../../constant';

const ViewFeesCollection = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let data = location.state;
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className="xl:flex xl:items-center xl:justify-between">
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Fees Collection Details
            </h1>
            <button type="button" className="btn btn-white" onClick={()=>navigate('/dashboard/fees-collection/')}>
              Back
            </button>
          </div>

          <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                    <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  </svg>
                  <span className="text-gray-600">
                    Student Id
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Created - <span>{showDate(data.created_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Updated - <span>{showDate(data.updated_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Deleted - <span>{showDate(data.deleted_at)}</span>
                  </span>
                </div>
              </div>
              <div className="mt-2 space-y-6">
                <div className="overflow-hidden bg-white rounded-lg shadow">
                  <div className="px-4 py-5 sm:p-6">
                    <div className="grid xl:grid-cols-6 gap-y-10">
                      <div className="xl:col-span-4 xl:pr-8 order-1 lg:order-1 md:order-2 sm:order-2 xs:order-2">
                        <div className="space-y-6">
                          <div>
                            <div className="flex items-center">
                              <p className="font-medium">
                                Fees Collection
                              </p>
                            </div>
      
                            <div className="mt-3 space-y-3">
                              <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                                <div className="px-4 py-5 sm:p-6">
                                  <div className="grid grid-cols-5 gap-5 md:grid-cols-5">
                                    <div className="col-span-3 md:col-span-3 md:order-1">
                                      <p className="text-sm text-gray-600">
                                        Total Fees
                                      </p>
                                      <p className="mt-1 text-lg leading-tight text-primary-600">
                                        {data.total_amount}/-
                                      </p>
                                    </div>

                                    <div className="col-span-1 md:col-span-1 sm:col-span-3 xs:col-span-3 md:order-1">
                                      <p className="text-sm text-gray-600">
                                        Course
                                      </p>
                                      <p className="mt-1 text-lg leading-tight text-primary-600">
                                        {data.courseData.name}
                                      </p>
                                    </div>

                                    <div className="col-span-1 md:col-span-1 sm:col-span-3 xs:col-span-3 md:order-1">
                                      <p className="text-sm text-gray-600">
                                        Admission Type
                                      </p>
                                      <p className="mt-1 text-lg leading-tight text-primary-600">
                                        {data.AdmissionData.type}
                                      </p>
                                    </div>
                                  </div>
      
                                  <table className="custom-table mt-5">
                                    <thead className=''>
                                      <tr>
                                        <th scope="col">
                                          Payment Type
                                        </th>
                                        <th scope="col" className="hidden xl:table-cell">
                                          Installments
                                        </th>
                                        <th scope="col" className="">
                                          Payment Date
                                        </th>
                                        <th scope="col" className="">
                                          Payment Status
                                        </th>
                                      </tr>
                                    </thead>
      
                                    <tbody id="elements-container">
                                      <tr className="draggable-element">
                                        <td className="hidden xl:table-cell whitespace-nowrap">
                                          {data.paymentType.type}
                                        </td>
                                        <td className="hidden xl:table-cell whitespace-nowrap">
                                          {data.installment}
                                        </td>
                                        <td>
                                          {showDate(data.payment_date)}
                                        </td>
                                        <td>
                                          Paid
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div className="xl:border-l xl:border-gray-200 xl:col-span-2 xl:pl-8 order-2 lg:order-2 md:order-1 sm:order-1 xs:order-1">
                        <div className="flex items-center justify-between">
                          <p className="font-medium">
                            Student Information
                          </p>
                        </div>
      
                        <div className='flex justify-between  !items-end'>
                          <h3 className="mt-4 text-2xl font-bold text-primary-600">
                            {data.studentData.firstname +" "+ data.studentData.lastname}
                          </h3>
      
                          <div className="flex items-center space-x-2">
                            <label htmlFor="">
                              Status
                            </label>
                            <div className="toggle-switch">
                              <input type="checkbox" checked={data.studentData.is_active} id="toggleSwitch" tabIndex="0" readOnly/>
                              <label htmlFor="toggleSwitch"></label>
                            </div>
                          </div>
                        </div>
      
                        <div className="grid grid-cols-2 mt-8 gap-x-8 gap-y-6">
                          <div>
                            <p className="text-sm text-gray-600">
                              Student Contact
                            </p>
                            <p className="mt-1">
                              {data.studentData.mobile}
                            </p>
                          </div>
      
                          <div>
                            <p className="text-sm text-gray-600">
                              Parents Contact
                            </p>
                            <p className="mt-1">
                              {data.studentData.parent_mobile}
                            </p>
                          </div>
      
                          <div>
                            <p className="text-sm text-gray-600">
                              Email
                            </p>
                            <p className="mt-1">
                              {data.studentData.email}
                            </p>
                          </div>
      
                          <div>
                            <p className="text-sm text-gray-600">
                              Address
                            </p>
                            <p className="mt-1">
                              {data.studentData.address}
                            </p>
                          </div>
                        </div>
      
                        <hr className="my-6 border-gray-200" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div> 
    </div>
  )
}

export default ViewFeesCollection
